import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  public CLIENT_TYPE = environment.CLIENT_TYPE;

  constructor(
    public router: Router
  ) { }

  ngOnInit() {
  }

  navigateToLoginPage() {
    this.router.navigate(['/user-login']);
  }
}
